export default "__VITE_ASSET__BaKQJyMu__"